import { DotsThreeVerticalIcon } from '@phosphor-icons/react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  Icon,
} from '@sr/ui-library';
import { ReactNode } from 'react';

interface IOptionsDropdown
  extends React.ComponentProps<typeof DropdownMenuContent> {
  children: ReactNode;
}

const OptionsDropdown = ({ children, ...props }: IOptionsDropdown) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <Icon
          data-testid="options-dropdown-icon"
          icon={DotsThreeVerticalIcon}
          weight="bold"
        />
        <span className="sr-only">Options</span>
      </DropdownMenuTrigger>

      <DropdownMenuContent {...props}>{children}</DropdownMenuContent>
    </DropdownMenu>
  );
};

export default OptionsDropdown;
